import 'list/scss/_list.scss'
import $ from 'jquery'
import Mustache from 'mustache'

//PolyFill
var URLSearchParams = require('url-search-params');

const MD_PROXY = require('proxy/proxy_config.js');
const LIST_TEMPLATE = require('../assets/list_template.html');
const TYPE_AHEAD_TEMPLATE = require('../assets/typeahead_template.html');

let sorting_select = {
   "en": {
      "options": [
         {
            "key": "",
            "text": "This is the default",
            "sortValue": "",
            "sortDirection": "",
            "attr":"disabled selected"
         },
         {
            "key": "date-asc",
            "text": "Date ascending",
            "sortValue": "&sort=entry",
            "sortDirection": "&order=asc",
            "attr":""
         },
         {
            "key": "date-desc",
            "text": "Date descending",
            "sortValue": "&sort=entry",
            "sortDirection": "&order=desc",
            "attr":""
         },
         {
            "key": "name-asc",
            "text": "Name ascending",
            "sortValue": "&sort=name",
            "sortDirection": "&order=asc",
            "attr":""
         },
         {
            "key": "name-desc",
            "text": "Name descending",
            "sortValue": "&sort=name",
            "sortDirection": "&order=desc",
            "attr":""
         },
         {
            "key": "num-asc",
            "text": "Inventorynumber ascending",
            "sortValue": "&sort=inventorynumber",
            "sortDirection": "&order=asc",
            "attr":""
         },
         {
            "key": "num-desc",
            "text": "Inventorynumber descending",
            "sortValue": "&sort=inventorynumber",
            "sortDirection": "&order=desc",
            "attr":""
         }
      ]
   },
   "de": {
      "options": [
         {
            "key": "",
            "text": "Sortiert nach",
            "sortValue": "",
            "sortDirection": "",
            "attr":"disabled selected"
         },
         {
            "key": "date-asc",
            "text": "Nach Eingangsdatum aufsteigend",
            "sortValue": "&sort=entry",
            "sortDirection": "&order=asc",
            "attr":""
         },
         {
            "key": "date-desc",
            "text": "Nach Eingangsdatum absteigend",
            "sortValue": "&sort=entry",
            "sortDirection": "&order=desc",
            "attr":""
         },
         {
            "key": "name-asc",
            "text": "Nach Name aufsteigend",
            "sortValue": "&sort=name",
            "sortDirection": "&order=asc",
            "attr":""
         },
         {
            "key": "name-desc",
            "text": "Nach Name absteigend",
            "sortValue": "&sort=name",
            "sortDirection": "&order=desc",
            "attr":""
         },
         {
            "key": "num-asc",
            "text": "Nach Eingangsnummer aufsteigend",
            "sortValue": "&sort=inventorynumber",
            "sortDirection": "&order=asc",
            "attr":""
         },
         {
            "key": "num-desc",
            "text": "Nach Eingangsnummer ab",
            "sortValue": "&sort=inventorynumber",
            "sortDirection": "&order=desc",
            "attr":""
         }
      ]
   }
}

//"https://bawue.museum-digital.de/index.php?ereignistyp_id=&persinst_id=&ort_id=&zeit_id=&tag_id=&t=objstart&st=objmulti_kontrolle&target=listen&title=&desc=&invno=&mattech=&size=&instnr=&gesusa=&metadata_rights=&metadata_rights_images=&submit=&per=&ort=&zei=11-12+n.+Chr.&tag=&obz=&alpha=&omega=&ereignistyp=&sv="

class MdList {
   constructor(elem) {
      const $this = $(elem),
         searchvalue = $this.data('object-id');

      this.elem = elem;
      this.renderNoResultsHint = false;
      this.resultsCount;
      this.headlineLevel = $this.data("headline-level");
      this.noResultsText = $this.data("no-results-text");
      this.detailLinkText = $this.data("detail-link-text"),


      this.lang = $this.data("lang");
      this.detailUrl = $this.data("detail-url");
      this.jsonSourceUrl = $this.data("ajax-url");
      this.assetUriObject = new URL( this.jsonSourceUrl );
      this.assetUri = this.assetUriObject.protocol + "//" + this.assetUriObject.host + "/";
      this.termUri = this.assetUri+"apis/"
      this.termIdUri = "https://term.museum-digital.de/md-"+this.lang+"/";
      this.assetUriSubdomain = this.assetUriObject.hostname.split('.');
      this.assetUriSubdomain  = this.assetUriSubdomain.shift();
      this.jsonSourceUrlParams = new URLSearchParams(this.jsonSourceUrl.split("?")[1]);
      this.instId = this.jsonSourceUrlParams.has("instnr") ? this.jsonSourceUrlParams.get("instnr") : "";
      this.instUri;
      if(this.instId !== ""){
         this.instUri = this.assetUri+"index.php?t=institution&output=json&instnr="+this.instId;
      }

      this.jsonSourceSVUrl = $this.data("ajax-sv-url");
      this.jsonStartParam = $this.data("current-start-param");
      this.jsonStepParam = $this.data("current-step-param");
      this.jsonSearchParam = $this.data("current-search-value-param");
      //if searchvalue is set Encode the searchValue
      if(this.jsonSearchParam !== ""){
         let jsonSearchParamArray = this.jsonSearchParam.split("=");
         this.jsonSearchParam = jsonSearchParamArray[0] + "=" + encodeURIComponent( jsonSearchParamArray[1] );
      }

      this.jsonSortParam = $this.data("current-sort-param");
      this.jsonOrderParam = $this.data("current-order-param");
      this.jsonTimeAlphaParam = $this.data("current-time-alpha-param");
      this.jsonTimeOmegaParam = $this.data("current-time-omega-param");



      this.searchTag = "&tag_id=";
      this.searchMaterial;
      this.searchOrt = "&ort_id=";
      this.searchPersonen = "&persinst_id=";
      this.searchObjektart;
      this.searchSammlung = "&gesusa=";
      this.searchInstitution = ""
      this.searchSerie ="&serie_id=";

      this.modals = $("#tagModal, #materialModal, #ortModal, #personenModal, #objektartModal, #sammlungModal");
      this.currentModal;
      this.currentJson = {};
      this.selectedTerms = new Array();

      //xhr-Objekte Global verfügbar machen um es abbrechen zu können.
      this.termXhr;
      this.resultXhr;

      //wenn von der Detaisleite aufgerufen wird werden diese Parameter benötigt.
      this.triggerSearch = $this.data("trigger-search");
      this.presetZeit ="";
      this.presetTag ="";
      this.presetPers ="";
      this.presetSammlung ="";
      this.presetSerie ="";
      this.presetOrt ="";

      if(this.triggerSearch !== ""){

         if( $this.data("zeit-id") !== ''){
            this.presetZeit = "&zeit_id="+$this.data("zeit-id");
         }
         if( $this.data("tag-id") !== ''){
            this.presetTag = "&tag_id="+$this.data("tag-id");
         }
         if( $this.data("pers-id") !== ''){
            this.presetPers = "&persinst_id="+$this.data("pers-id");
         }
         if( $this.data("sammlungs-id") !== ''){
            this.presetSammlung = "&gesusa="+$this.data("sammlungs-id");
         }
         if( $this.data("serie-id") !== ''){
            this.presetSerie = "&serie_id="+$this.data("serie-id");
         }
         if( $this.data("ort-id") !== ''){
            this.presetOrt = "&ort_id="+$this.data("ort-id");
         }

         this.initPresetSearch();
      }
      this.init_selects();
      this.init_events();
   }

   pagination(c, m) {
      let current = c,
         last = m,
         delta = 2,
         left = current - delta,
         right = current + delta + 1,
         range = [],
         rangeWithDots = [],
         l,
         jsonStepParamArray = this.jsonStepParam.split("=");

      for (let i = 1; i <= last; i++) {
         if (i == 1 || i == last || i >= left && i < right) {
            let paginationUri = '?start_val=' + i * parseInt(jsonStepParamArray[1]) + '&step_val=' + parseInt(jsonStepParamArray[1]) + this.jsonSortParam + this.jsonOrderParam;
            let classList = "";

            if (i === current) {
               classList = "active";
            }

            let paginationItem = {
               "page": i,
               "url": paginationUri,
               "text": i,
               "class": classList
            }
            range.push(paginationItem);
         }
      }

      for (let i of range) {


         if (l) {

            if (i.text - l === 2) {
               rangeWithDots.push(l + 1);
            } else if (i.text - l !== 1) {
               let paginationItem = {
                  "text": "...",
                  "class": classList,
                  "no-link": true
               }
               rangeWithDots.push(paginationItem);
            }
         }

         let paginationUri = '?start_val=' + i.text * parseInt(jsonStepParamArray[1]) + '&step_val=' + parseInt(jsonStepParamArray[1]) + this.jsonSortParam + this.jsonOrderParam;
         let classList = "";
         if (i.text === current) {
            classList = "active";
         }
         let paginationItem = {
            "page": i.text,
            "title": "Zur Ergebnisseite "+i.text+" springen.",
            "url": paginationUri,
            "text": i.text,
            "class": classList
         }
         rangeWithDots.push(paginationItem);

         l = i.text;
      }


      if (rangeWithDots.length > 0) {
         let paginationPrev = {
            "page": 0,
            "url": "#",
            "title": "Eine Ergebnisseite zurück springen.",
            "text": "<i class='icon icon-slider-arrow-left'></i>",
            "class": "prev"
         }
         rangeWithDots.unshift(paginationPrev);
         let paginationNext = {
            "page": 0,
            "url": "#",
            "title": "Eine Ergebnisseite vor springen.",
            "text": "<i class='icon icon-slider-arrow-right'></i>",
            "class": "next"
         }
         rangeWithDots.push(paginationNext);
      }

      return rangeWithDots;
   }

   callAjaxWithAllParams() {
      let resultXHR;
      $(this.elem).addClass("loading");

      if( this.jsonSearchParam.split("=")[1] !== "" ){
         resultXHR = this.get_ajax_result(this.jsonSourceSVUrl + this.jsonStartParam + this.jsonStepParam + this.jsonSortParam + this.jsonOrderParam + this.jsonTimeAlphaParam + this.jsonTimeOmegaParam + this.jsonSearchParam + this.searchTag + this.searchOrt + this.searchPersonen + this.searchSammlung + this.searchInstitution + this.presetTag+this.presetZeit+this.presetPers+this.presetSammlung+this.presetSerie+this.presetOrt);
      }else{
         resultXHR = this.get_ajax_result(this.jsonSourceUrl + this.jsonStartParam + this.jsonStepParam + this.jsonSortParam + this.jsonOrderParam + this.jsonTimeAlphaParam + this.jsonTimeOmegaParam + this.searchTag + this.searchOrt + this.searchPersonen + this.searchSammlung + this.searchInstitution + this.presetTag+this.presetZeit+this.presetPers+this.presetSammlung+this.presetSerie+this.presetOrt);
      }

      $.when(resultXHR).then((result) => {
         this.html_output(result);
         $(this.elem).removeClass("loading");
      }).fail(()=> {
         this.html_output([]);
         $(this.elem).removeClass("loading");
      });
   }

   get_term_ajax_result(jsonUrl, abort) {
      //Abort previous xhr
      if(  typeof this.termXhr !== 'undefined' && abort){
         this.termXhr.abort();
      }

      this.termXhr = MD_PROXY.ajax(jsonUrl);

      return this.termXhr;
   }

   typeahead_html_output(jsonResults, target) {
      let view = {
         results: jsonResults
      };
      $(".results", target).empty();
      $(".results", target).append(Mustache.render(TYPE_AHEAD_TEMPLATE, view));
   }

   selected_html_output(jsonResults) {
      let view = {
         results: jsonResults
      };
      $(".selected-results", this.elem).empty();
      $(".selected-results", this.elem).append(Mustache.render(TYPE_AHEAD_TEMPLATE, view));
   }

   get_ajax_result(jsonUrl) {
      //Abort previous xhr
      if(  typeof this.resultXhr !== 'undefined' ){
         this.resultXhr.abort();
      }

      this.resultXhr = MD_PROXY.ajax(jsonUrl);

      this.currentJson = this.resultXhr;
      return this.resultXhr;
   }

   html_output(jsonResult) {
      let resultsObjectArray = new Array();

      let resultsObject = jsonResult;
      const detailUrlArray = this.detailUrl.split("?");
      let detailUrlParams = new URLSearchParams(detailUrlArray[1]);

      if (resultsObject.length > 0 && jsonResult.error !== "error" && jsonResult.status !== "Error") {
         this.resultsCount = resultsObject[0].total;
         this.renderNoResultsHint = false;
      } else {
         this.resultsCount = "0";
         this.renderNoResultsHint = true;
         resultsObject = {};
      }

      const headline = $(".results-wrap", this.elem).data("headline");
      const reset = $(".results-wrap", this.elem).data("reset");

      if(resultsObject.length > 0){
         resultsObject.map((resultObject, resultKey) => {

            const imagePath = this.assetUri + resultObject.image;

            detailUrlParams.set("dk_object_id", resultObject.objekt_id);

            const view = {
               imagePath: imagePath,
               objectId: resultObject.objekt_id,
               name: resultObject.objekt_name,
               description: resultObject.objekt_beschreibung.replace(new RegExp('\r?\n','g'), '<br />'),
               detailUri: detailUrlArray[0]+"?"+detailUrlParams.toString()
            }

            resultsObjectArray.push(view);
         });
      }

      let jsonStepParamArray = this.jsonStepParam.split("=");
      let jsonStartParamArray = this.jsonStartParam.split("=");

      let view = {
         sorting: sorting_select[this.lang],
         headline: headline,
         headlineLevel: this.headlineLevel,
         headlineLevel2: this.headlineLevel+1,
         headlineLevel3: this.headlineLevel+2,
         reset: reset,
         pagination: this.pagination(Math.ceil((parseInt(jsonStartParamArray[1]) + 1) / parseInt(jsonStepParamArray[1])), Math.ceil(parseInt(this.resultsCount) / parseInt(jsonStepParamArray[1]))),
         resultsCount: this.resultsCount,
         renderNoResultsHint: this.renderNoResultsHint,
         noResultsText: this.noResultsText,
         detailText: this.detailText,
         detailLinkText: this.detailLinkText,
         results: resultsObjectArray
      }

      $(".results-wrap", this.elem).empty();
      $(".results-wrap", this.elem).append(Mustache.render(LIST_TEMPLATE, view));
   }

   //Spezialfälle bei Suchaufrufen aus der Detailseite.
   initPresetSearch(){
      let results = new Array();

      if( $(this.elem).data("tag-id") ){
         let presetTag =  this.get_term_ajax_result(this.termIdUri + "tag/" + encodeURIComponent( $(this.elem).data("tag-id") ) +"/json?navlang="+this.lang, false);
         $.when(presetTag).then((xhrResult) => {
            let result = {
               "id": xhrResult.id,
               "value": xhrResult.name,
               "searchType": "presetTag"
            };
            console.log(xhrResult);
            results.push(result);
            this.selected_html_output(results);
         });
      }
      if( $(this.elem).data("zeit-id") ){
         let presetZeit = this.get_term_ajax_result(this.termIdUri + "time/" + encodeURIComponent( $(this.elem).data("zeit-id") ) +"/json?navlang="+this.lang, false);
         $.when(presetZeit).then((xhrResult) => {
            let result = {
               "id": xhrResult.id,
               "value": xhrResult.name,
               "searchType": "presetZeit"
            };
            results.push(result);
            this.selected_html_output(results);
         });
      }
      if( $(this.elem).data("pers-id") ){
         let presetPers = this.get_term_ajax_result(this.termIdUri + "persinst/" + encodeURIComponent( $(this.elem).data("pers-id") ) +"/json?navlang="+this.lang, false);

         $.when(presetPers).then((xhrResult) => {
            let result = {
               "id": xhrResult.id,
               "value": xhrResult.name,
               "searchType": "presetPers"
            };

            results.push(result);
            this.selected_html_output(results);
         });
      }

      if( $(this.elem).data("ort-id") ){
         let presetOrt = this.get_term_ajax_result(this.termIdUri + "place/" + encodeURIComponent( $(this.elem).data("ort-id") ) +"/json?navlang="+this.lang, false);

         $.when(presetOrt).then((xhrResult) => {
            let result = {
               "id": xhrResult.id,
               "value": xhrResult.name,
               "searchType": "presetOrt"
            };

            results.push(result);
            this.selected_html_output(results);
         });
      }

      if( $(this.elem).data("sammlungs-id") ){

         const resultXHR = this.get_term_ajax_result(this.instUri, false);

         $.when(resultXHR).then((result) => {
            let collections = result.collections;
            let options = new Array();
            $.each(collections, (termkey, termObject) => {
               if( $(this.elem).data("sammlungs-id") === termObject.collection_id){
                  let result = {
                     "id": termObject.collection_id,
                     "value": termObject.collection_name,
                     "searchType": "presetSammlung"
                  };
                  results.push(result);
                  this.selected_html_output(results);
               }
               $.each(termObject.collection_subcollections, (subcollectionKey, subcollectionObject) => {
                  if( subcollectionObject.collection_no_of_objects !== "0" ){
                     if( $(this.elem).data("sammlungs-id") === subcollectionObject.collection_id){
                        let result = {
                           "id": subcollectionObject.collection_id,
                           "value": subcollectionObject.collection_name,
                           "searchType": "presetSammlung"
                        };
                        results.push(result);
                        this.selected_html_output(results);
                     }
                  }
               });
            });

         });
      }

      if( $(this.elem).data("serie-id") ){
         let presetSerie = this.get_term_ajax_result(this.assetUri + "index.php?t=serie&serges="+$(this.elem).data("serie-id")+"&output=json", false);

         $.when(presetSerie).then((xhrResult) => {console.log(xhrResult);
            let result = {
               "id": xhrResult.series_id,
               "value": xhrResult.series_name,
               "searchType": "presetSerie"
            };

            results.push(result);
            this.selected_html_output(results);
         });
      }

      this.callAjaxWithAllParams();
   }

   init_events() {

      $(this.elem).on("click", ".pagination-wrapper a", (event) => {
         event.preventDefault();
         let link = event.currentTarget;

         let paginationValue = $(link).data("pagination");
         let jsonStartParamArray = this.jsonStartParam.split("=");
         let jsonStepParamArray = this.jsonStepParam.split("=");


         if (paginationValue > 0) {
            this.jsonStartParam = jsonStartParamArray[0] + "=" + jsonStepParamArray[1] * (paginationValue - 1);
         } else {
            if ($(link).hasClass("prev")) {
               let startNumber = parseInt(jsonStartParamArray[1], 10) - parseInt(jsonStepParamArray[1], 10);
               this.jsonStartParam = jsonStartParamArray[0] + "=" + Math.max(0, startNumber);
            } else if ($(link).hasClass("next")) {
               let startNumber = parseInt(jsonStartParamArray[1], 10) + parseInt(jsonStepParamArray[1], 10);
               this.jsonStartParam = jsonStartParamArray[0] + "=" + Math.min(this.resultsCount, startNumber);
            }
         }
         $("html, body").animate({
              scrollTop: $(".results-wrap",this.elem).first().offset().top - 100
          }, 150);
         this.callAjaxWithAllParams();
      });

      $(this.elem).on("change keyup", "#alpha, #alpha-manipulator", (event) => {
         let input = event.currentTarget;
         let time = $("#alpha").val();
         let manipulator = $("#alpha-manipulator option:selected").val();
         let jsonTimeAlphaParamArray = this.jsonTimeAlphaParam.split("=");
         //reset des presetsZeit, dieser muss entfertn werden wenn diese Suche verwendet wird.
         this.presetZeit ="";
         $(".selected-results [data-search-type='presetZeit']", this.elem ).remove();

         if (manipulator === "bc") {
            //Zahl IMMER Negativ
            time = -Math.abs(time)
         } else if (manipulator === "ad") {
            //Zahl IMMER Negativ
            time = Math.abs(time)
         }

         this.jsonTimeAlphaParam = jsonTimeAlphaParamArray[0] + "=" + time;

         this.jsonStartParam = $(this.elem).data("current-start-param");

         this.callAjaxWithAllParams();
      });

      $(this.elem).on("change keyup", "#omega, #omega-manipulator", (event) => {
         let input = event.currentTarget;
         let time = $("#omega").val();
         let manipulator = $("#omega-manipulator option:selected").val();
         let jsonTimeOmegaParamArray = this.jsonTimeOmegaParam.split("=");

         //reset des presetsZeit, dieser muss entfertn werden wenn diese Suche verwendet wird.
         this.presetZeit ="";
         $(".selected-results [data-search-type='presetZeit']", this.elem).remove();

         if (manipulator === "bc" && time !== "") {
            //Zahl IMMER Negativ
            time = -Math.abs(time)
         } else if (manipulator === "ad" && time !== "") {
            //Zahl IMMER Negativ
            time = Math.abs(time)
         }

         this.jsonTimeOmegaParam = jsonTimeOmegaParamArray[0] + "=" + time;

         this.jsonStartParam = $(this.elem).data("current-start-param");

         this.callAjaxWithAllParams();
      });


      $(this.elem).on("change", "#sorting", (event) => {
         let select = event.currentTarget;
         let paramlist = $(select).val().split("|");
         let jsonStartParamArray = this.jsonStartParam.split("=");

         if( $(select).val() !== "|"){
            $(sorting_select[this.lang].options).each((key, option) => {
               //Remeber selected sorting value,
               if( option.sortValue+"|"+option.sortDirection === $(select).val() ){
                  sorting_select[this.lang].options[key].attr = "selected";
               }else{
                  sorting_select[this.lang].options[key].attr = "";
               }
               //Always remove the the selected Option, from the "Label"-Entry
               sorting_select[this.lang].options[0].attr = "disabled";
            })
            this.jsonStartParam = jsonStartParamArray[0] + "=" + 0;
            this.jsonSortParam = paramlist[0];
            this.jsonOrderParam = paramlist[1];

            this.callAjaxWithAllParams();
         }
      });

      $(this.elem).on("change keyup", ".searchvalue", (event) => {
         let searchObject = event.currentTarget;
         let searchvalue = $(searchObject).val();

         if (searchvalue.length >= 3 || searchvalue.length === 0) {
            let jsonSearchParamArray = this.jsonSearchParam.split("=");

            this.jsonSearchParam = jsonSearchParamArray[0] + "=" + encodeURIComponent( searchvalue );

            this.jsonStartParam = $(this.elem).data("current-start-param");

            this.callAjaxWithAllParams();
         }else{
            let jsonSearchParamArray = this.jsonSearchParam.split("=");
            this.jsonSearchParam = jsonSearchParamArray[0] + "=";
         }

      });

      this.modals.on("change keyup", "[type=text]", (event) => {

         let searchObject = event.currentTarget;
         let searchvalue = $(searchObject).val();
         let kind;

         switch ($(searchObject).parents(".modal").attr("id")) {
            case "tagModal":
               kind = "search_tag.php";
               break;
            case "materialModal":
               kind = "material";
               break;
            case "ortModal":
               kind = "search_ort.php";
               break;
            case "personenModal":
               kind = "search_per.php";
               break;
            case "objektartModal":
               kind = "type";
               break;
            case "sammlungModal":
               kind = "sammlung";
               break;
         }

         let currentModal = $(searchObject).parents(".modal");
         let inst = this.instId ? "&suinin="+this.instId : "";
         currentModal.addClass("loading");
         this.currentModal = currentModal;

         //const resultXHR = this.get_term_ajax_result(this.termUri + "&kind=" + kind + "|md-de&search=" + encodeURIComponent(searchvalue));
         const resultXHR = this.get_term_ajax_result(this.termUri + kind + "?term=" + encodeURIComponent(searchvalue)+"&navlang="+this.lang+inst, true);

         $.when(resultXHR).then((result) => {
            this.typeahead_html_output(result, currentModal);
            currentModal.removeClass("loading");
         });

      });


      this.modals.on("change", "select", (event) => {

         let searchObject = event.currentTarget;
         let searchvalue = $(searchObject).val();
         let searchText = $("option:selected", searchObject).text();
         let kind;

         switch ($(searchObject).parents(".modal").attr("id")) {
            case "tagModal":
               kind = "tag";
               break;
            case "materialModal":
               kind = "material";
               break;
            case "ortModal":
               kind = "place";
               break;
            case "personenModal":
               kind = "persinst";
               break;
            case "objektartModal":
               kind = "type";
               break;
            case "sammlungModal":
               kind = "sammlung";
               this.searchSammlung = "&gesusa="+searchvalue;
               break;
         }

         let currentModal = $(searchObject).parents(".modal");

         this.selectedTerms.map((termObject, termKey) => {
            if (termObject.searchType === kind) {
               this.selectedTerms.splice(termKey, 1);
            }
         });

         if(searchvalue !== ""){
            let result = {
               "id": searchvalue,
               "value": searchText,
               "searchType": kind
            };

            this.selectedTerms.push(result);
         }

         $(".close-modal", currentModal).click();

         this.jsonStartParam = $(this.elem).data("current-start-param");

         this.selected_html_output(this.selectedTerms);

         this.callAjaxWithAllParams();
         $(".close-modal", currentModal).click();
      });


      this.modals.on("click", ".result", (event) => {

         let searchObject = event.currentTarget;
         this.currentModal = $(searchObject).parents(".modal");

         let searchText = $(".content-wrap", searchObject).text();
         let searchId = $(searchObject).data("md-id");
         let searchType;

         switch ($(searchObject).parents(".modal").attr("id")) {
            case "tagModal":
               this.searchTag = "&tag_id=" + searchId;
               //mitgenommene Tags löschen
               this.presetTag ="";
               $(".selected-results [data-search-type='presetTag']", this.elem).remove();
               searchType = "tag";
               break;
            case "materialModal":
               this.searchMaterial = searchId;
               searchType = "material";
               break;
            case "ortModal":
               this.searchOrt = "&ort_id=" + searchId;
               searchType = "ort";
               $(".selected-results [data-search-type='presetOrt']", this.elem).remove();
               break;
            case "personenModal":
               this.searchPersonen = "&persinst_id=" + searchId;
               //mitgenommene Personen und Institutionen löschen
               this.presetPers ="";
               $(".selected-results [data-search-type='presetPers']", this.elem).remove();
               searchType = "personen";
               break;
            case "objektartModal":
               this.searchObjektart = searchId;
               searchType = "objekt";
               break;
            case "sammlungModal":
               this.searchSammlung = searchId;
               searchType = "sammlung";
               break;
         }

         let result = {
            "id": searchId,
            "value": searchText,
            "searchType": searchType
         };

         this.selectedTerms.map((termObject, termKey) => {
            if (termObject.searchType === searchType) {
               this.selectedTerms.splice(termKey, 1);
            }
         });

         this.selectedTerms.push(result);

         $("[type=text]", this.currentModal).val(searchText);
         $("[type=text]", this.currentModal).trigger("change");
         $(".close-modal", this.currentModal).click();

         this.jsonStartParam = $(this.elem).data("current-start-param");

         this.selected_html_output(this.selectedTerms);
         this.callAjaxWithAllParams();
      });

      $(this.elem).on("click", ".reset", (event) => {
         event.preventDefault();
         let jsonSearchParamArray = this.jsonSearchParam.split("=");
         this.searchTag = "&tag_id="
         this.searchMaterial = "";
         this.searchOrt = "&ort_id=";
         this.searchPersonen = "&persinst_id=";
         this.searchInstitution = "";
         this.searchObjektart = "";
         this.searchSammlung = "&gesusa=";
         this.presetSerie = "&serie_id=";
         this.selectedTerms = new Array();


         this.jsonStartParam = $(this.elem).data("current-start-param");
         this.jsonStepParam = $(this.elem).data("current-step-param");
         this.jsonSortParam = $(this.elem).data("current-sort-param");
         this.jsonOrderParam = $(this.elem).data("current-order-param");
         this.jsonTimeAlphaParam = $(this.elem).data("current-time-alpha-param");
         this.jsonTimeOmegaParam = $(this.elem).data("current-time-omega-param");
         this.jsonSearchParam = jsonSearchParamArray[0] + "=";
         this.triggerSearch = "";
         this.presetZeit = "";
         this.presetTag = "";
         this.presetPers = "";
         this.presetSammlung = "";
         this.presetSerie = "";


         $(".selected-results", this.elem).empty();
         $("select", this.modals).val("");
         $("[type=text]", this.modals).val("");
         $(".results", this.modals).empty();
         $("[type=text]", this.elem).val("");
         $("#alpha-manipulator", this.elem).val($("#alpha-manipulator", this.elem).find('option').val("ad") );
         $("#omega-manipulator", this.elem).val($("#omega-manipulator", this.elem).find('option').val("ad") );
         $("#sorting", this.elem).val($("#sorting", this.elem).find('option').first().val());

         this.callAjaxWithAllParams();
      });

      $(this.elem).on("click", ".selected-results .result", (event) => {

         let searchObject = event.currentTarget;
         let searchType = $(searchObject).data("search-type");

         switch (searchType) {
            case "tag":
               this.searchTag = "&tag_id="
               break;
            case "material":
               this.searchMaterial = "";
               break;
            case "ort":
               this.searchOrt = "&ort_id=";
               break;
            case "personen":
               this.searchPersonen = "&persinst_id=";
               break;
            case "objektart":
               this.searchObjektart = "";
               break;
            case "sammlung":
               $("#dropdown-collection", this.modals).val("");
               this.searchSammlung = "&gesusa=";
               break;
            //Spezialfälle bei Suchaufrufen aus der Detailseite.
            case "presetTag":
               this.presetTag = "";
               break
            case "presetZeit":
               this.presetZeit = "";
               break
            case "presetPers":
               this.presetPers = "";
               break
            case "presetSammlung":
               this.presetSammlung = "";
               break
            case "presetOrt":
               this.presetOrt = "";
               break
            case "presetSerie":
               this.presetSerie = "";
               break
         }

         this.selectedTerms.map((termObject, termKey) => {
            if (termObject.searchType === searchType) {
               this.selectedTerms.splice(termKey, 1);
            }
         });

         $(searchObject).remove();
         $("#" + searchType + "Modal [type='text']").val("");
         $("#" + searchType + "Modal .results").empty();

         this.jsonStartParam = $(this.elem).data("current-start-param");

         this.callAjaxWithAllParams();
      });

      $(this.elem).on("click", ".show-all", (event) => {
         event.preventDefault();
         $(".reset", this.elem).trigger("click");
         
         this.callAjaxWithAllParams();
      });
   }

   //Dropdowns bevölkern.

   init_selects(){
      const resultXHR = this.get_term_ajax_result(this.instUri, false);

      $.when(resultXHR).then((result) => {
         let collections = result.collections;
         let options = new Array();
         //console.log(collections);

         $.each(collections, (termkey, termObject) => {
            if( termObject.collection_number_of_objects !== 0 ){
               options.push( "<option value="+termObject.collection_id+">"+termObject.collection_name+"</option>" );
               $.each(termObject.collection_subcollections, (subcollectionKey, subcollectionObject) => {
                  if( subcollectionObject.collection_no_of_objects !== "0" ){
                     options.push( "<option value="+subcollectionObject.collection_id+">"+subcollectionObject.collection_name+"</option>" );
                  }
               });
            }
         });

         $("#dropdown-collection", this.modals).append(options.join(""));
      });
   }
}

class MdListManager {
   constructor() {
      this.MdLists = $('.md-list').toArray().reduce((a, e) => ({
         [e]: new MdList(e),
         ...a
      }), {});
   }
}

$(function() {
   if ($('.md-list').length > 0) {
      const MdLists = new MdListManager();
   }
});